import { apiUrl } from "../../../setting";

export const getDayBookUrl = () => {
    return `${apiUrl}/routes/daybook/getDayBookRecord`;
};

export const getGroupedDataUrl = () => {
    return `${apiUrl}/routes/daybook/getGroupedData`;
};